import { render, staticRenderFns } from "./ItemCategoriesList.vue?vue&type=template&id=5ab9797a&scoped=true"
import script from "./ItemCategoriesList.vue?vue&type=script&lang=js"
export * from "./ItemCategoriesList.vue?vue&type=script&lang=js"
import style0 from "./ItemCategoriesList.vue?vue&type=style&index=0&id=5ab9797a&prod&lang=scss&scoped=true"
import style1 from "./ItemCategoriesList.vue?vue&type=style&index=1&id=5ab9797a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab9797a",
  null
  
)

export default component.exports